// src/App.js

import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  useLocation,
} from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import TimerApp from "./components/Timer/TimerApp";
import SplitterApp from "./components/Splitter/SplitterApp";
import AudioPlayerApp from "./components/Pulse/AudioPlayerApp";
import HabitTracker from "./components/Habits/HabitTracker";
import ContactForm from "./components/Contact/ContactForm"; // ✅ Import the contact form
import { HabitProvider } from "./components/Habits/context/HabitContext";
import "./App.css";
import { useSettings } from "./hooks/useSettings";
import Footer from "./components/Footer/Footer";
import Home from './components/Home/Home';
import { initGA, trackPageView } from "./utils/analytics";
import { HelmetProvider } from "react-helmet-async";

function GAWrapper({ children }) {
  const location = useLocation();

  useEffect(() => {
    initGA();
  }, []);

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return children;
}

function App() {
  const [settings] = useSettings();

  useEffect(() => {
    document.body.className =
      settings.theme === "light" ? "light-theme" : "dark-theme";
  }, [settings.theme]);

  return (
    <HelmetProvider>
      <Router>
        <HabitProvider>
          <GAWrapper>
            <div className="App">
              <Navbar />
              <div className="main-content">
                <Switch>
                  <Route exact path="/">
                    <Home />
                  </Route>
                  <Route path="/timer">
                    <TimerApp />
                  </Route>
                  <Route path="/splitter">
                    <SplitterApp />
                  </Route>
                  <Route path="/pulse">
                    <AudioPlayerApp />
                  </Route>
                  <Route path="/habits">
                    <HabitTracker />
                  </Route>
                  <Route path="/contact">
                    <ContactForm />
                  </Route>
                  <Redirect to="/" />
                </Switch>
              </div>
              <Footer />
            </div>
          </GAWrapper>
        </HabitProvider>
      </Router>
    </HelmetProvider>
  );
}

export default App;
